module.exports = "https://img.zhijierongxing.com/saas/img/dayicon.dd421ef2.png";